<div class="stat-card" [class]="'stat-card--' + variant">
  <!-- Loading State -->
  <div *ngIf="loading" class="stat-card__loading">
    <div class="stat-card__skeleton stat-card__skeleton--icon"></div>
    <div class="stat-card__skeleton-content">
      <div class="stat-card__skeleton stat-card__skeleton--title"></div>
      <div class="stat-card__skeleton stat-card__skeleton--value"></div>
    </div>
  </div>

  <!-- Content -->
  <div *ngIf="!loading" class="stat-card__content">
    <!-- Icon -->
    <div *ngIf="icon" class="stat-card__icon">
      <i [class]="icon"></i>
    </div>

    <!-- Text Content -->
    <div class="stat-card__text">
      <p class="stat-card__title">{{ title }}</p>
      <h3 class="stat-card__value">{{ value }}</h3>
      <p *ngIf="subtitle" class="stat-card__subtitle">{{ subtitle }}</p>
    </div>

    <!-- Trend Indicator -->
    <div *ngIf="trend !== undefined" class="stat-card__trend" [class]="'stat-card__trend--' + trendDirection">
      <i [class]="trendIconClass"></i>
      <span class="stat-card__trend-value">{{ trend > 0 ? '+' : '' }}{{ trend }}%</span>
      <span *ngIf="trendLabel" class="stat-card__trend-label">{{ trendLabel }}</span>
    </div>
  </div>
</div>
